export class Vehicle {
    id!: number;
    name!: string;
    available!: boolean;
    type!: VehicleType;
}

export enum VehicleType {
    Car = 'CAR',
    MotorCycle = 'MOTORCYCLE',
    Bicycle = 'BIKE'
}